import React from 'react';
import { motion } from 'framer-motion';

export const About = () => {
  return (
    <section className="py-20 md:py-32 px-6 bg-[#fffef2]">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img
              src="https://customer-assets-cm19k8pv.emergentagent.net/job_become-unstoppable-1/artifacts/wdc8ki9o_2405EBDA-48B3-4ED0-B1DF-8AD0F2751F47.jpg"
              alt="Garima - Transformation Coach"
              className="w-full h-auto shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <div>
              <span className="inline-block bg-[#8B6F47] text-white px-4 py-1 text-sm font-medium tracking-wide uppercase mb-4">
                About
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-6">
                Meet Garima
              </h2>
              <h3 className="text-2xl font-semibold text-[#666666] mb-6">
                From Corporate to Conscious
              </h3>
            </div>

            <div className="space-y-4 text-lg text-[#666666] leading-relaxed">
              <p>
                I spent years climbing the ladder, ticking boxes, and wondering why success felt empty.
              </p>
              <p>
                The shift didn't happen overnight. It happened the day I chose myself over comfort. The day I stopped seeking validation and started seeking truth.
              </p>
              <p>
                Now, I help others do the same. Not through theory, but through transformation. Through deep inner work that creates lasting change.
              </p>
              <p>
                This isn't about becoming someone new. It's about becoming who you already are — without the fear, without the doubt, without the limits you've accepted as truth.
              </p>
            </div>

            <div className="pt-4">
              <p className="text-2xl font-semibold text-[#333333] italic">
                "This work changed my life. Now I help others do the same."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
